import { ExternalFinancialEntity } from '../../financialEntities';
import { useGoalsFundedByAccount } from './useGoalsFundedByAccount';

export const useIsActiveFundingAccount = (
    account?: ExternalFinancialEntity
): boolean => {
    const goalsFundedByAccount = useGoalsFundedByAccount(account);

    return goalsFundedByAccount.some(({ transactionSchedules }) =>
        transactionSchedules.find((ts) => ts.status === 'ACTIVE')
    );
};
